import { useState } from 'react';
import { Settings } from 'lucide-react';
import { useLanguage } from '@/hooks/useLanguage';
import { getConsentTranslation } from '@/i18n/consent-translations';
import { loadConsentState, ConsentPreferences, saveConsentState } from '@/lib/tracking/consent-store';
import { loadTrackingScripts } from '@/lib/tracking/script-loader';
import PreferencesModal from './PreferencesModal';

interface ManageCookiesLinkProps {
  className?: string;
  showIcon?: boolean;
  variant?: 'link' | 'button';
}

const ManageCookiesLink = ({ 
  className = '', 
  showIcon = true,
  variant = 'link' 
}: ManageCookiesLinkProps) => {
  const { language } = useLanguage();
  const t = getConsentTranslation(language);
  const [showModal, setShowModal] = useState(false);

  const handleSavePreferences = async (preferences: ConsentPreferences) => {
    await saveConsentState(preferences, language);
    loadTrackingScripts(preferences);
    setShowModal(false);
  };

  const baseClass = variant === 'button'
    ? 'inline-flex items-center px-3 py-1.5 text-sm bg-muted hover:bg-muted/80 rounded-md transition-colors'
    : 'inline-flex items-center text-sm text-muted-foreground hover:text-foreground transition-colors';

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className={`${baseClass} ${className}`}
        aria-label={t.footer.manageCookies}
      >
        {showIcon && <Settings className="h-4 w-4 mr-1.5" />}
        {t.footer.manageCookies}
      </button>

      <PreferencesModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSave={handleSavePreferences}
      />
    </>
  );
};

export default ManageCookiesLink;
